<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 100px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 100px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มประเภทการลงเวลา</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title>{{ duty.title_th }}</v-list-item-title>
            <v-list-item-subtitle>
              {{ duty.title_en }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <label class="body-2">
          ชื่อ
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="1"
          v-model="duty.title_th"
          :rules="[(v) => !!v || 'โปรดระบุชื่อ']"
          required
          clearable
          @change="checkEmpty($event, 'title_th')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2">
          ชื่อ (อังกฤษ)
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="2"
          v-model="duty.title_en"
          :rules="[(v) => !!v || 'โปรดระบุชื่อ (อังกฤษ)']"
          required
          clearable
          @change="checkEmpty($event, 'title_en')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2"> รหัส </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="3"
          v-model="duty.duty_code"
          counter="1"
          maxlength="1"
          clearable
          @change="checkEmpty($event, 'duty_code')"
          outlined
          dense
        ></v-text-field>
        <label class="body-2">
          ประเภท
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-autocomplete
          class="fix-google-chrome mt-1"
          v-model="duty.duty_type_id"
          :rules="[(v) => !!v || 'โปรดระบุประเภท']"
          :items="dutiesType"
          item-text="title_th"
          item-value="duty_type_id"
          outlined
          dense
        >
        </v-autocomplete>
        <!-- <v-dialog
          ref="dialogStartTime"
          v-model="modalStartTime"
          :return-value.sync="duty.start_time"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <div>
              <label class="body-2"> เวลาเริ่มต้น </label>
              <v-text-field
                class="fix-google-chrome mt-1"
                :value="duty.start_time"
                :rules="[ruleStartTime || 'จำเป็นต้องใส่เวลา']"
                append-icon="mdi-clock-outline"
                @click:append="modalStartTime = true"
                readonly
                v-bind="attrs"
                v-on="on"
                clearable
                @click:clear="dutyClear('start_time')"
                outlined
                dense
              ></v-text-field>
            </div>
          </template>
          <v-time-picker
            v-if="modalStartTime"
            v-model="duty.start_time"
            full-width
            format="24hr"
            use-seconds
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="modalStartTime = false"
              >ยกเลิก
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.dialogStartTime.save(duty.start_time)"
              >ตกลง
            </v-btn>
          </v-time-picker>
        </v-dialog>
        <v-dialog
          ref="dialogEndTime"
          v-model="modalEndTime"
          :return-value.sync="duty.end_time"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <div>
              <label class="body-2"> เวลาสิ้นสุด </label>
              <v-text-field
                class="fix-google-chrome mt-1"
                :value="duty.end_time"
                :rules="[ruleEndTime || 'จำเป็นต้องใส่เวลา']"
                append-icon="mdi-clock-outline"
                @click:append="modalEndTime = true"
                readonly
                v-bind="attrs"
                v-on="on"
                clearable
                @click:clear="dutyClear('end_time')"
                outlined
                dense
              ></v-text-field>
            </div>
          </template>
          <v-time-picker
            v-if="modalEndTime"
            v-model="duty.end_time"
            full-width
            format="24hr"
            use-seconds
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="modalEndTime = false"
              >ยกเลิก
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.dialogEndTime.save(duty.end_time)"
              >ตกลง
            </v-btn>
          </v-time-picker>
        </v-dialog> -->
        <!-- <v-row>
          <v-checkbox
            v-model="duty.is_office"
            class="mx-2"
            label="สำนักงาน"
          ></v-checkbox>
          <v-checkbox
            v-model="duty.is_display_on_mobile"
            class="mx-2"
            label="แอพ"
          ></v-checkbox>
        </v-row> -->
        <!-- <v-row class="mt-2">
          <div class="d-flex flex-column mx-3">
            <label>ใช้ประเภทการลงเวลานี้บน Device</label>
            <v-checkbox
              v-model="duty.is_display_on_mobile"
              class="mt-2 px-5"
              hide-details
              label="แอพ"
            ></v-checkbox>
            <v-checkbox disabled class="mt-2 px-5" label="Device"></v-checkbox>
          </div>
        </v-row> -->
        <!-- <v-row v-if="duty.is_display_on_mobile">
          <div class="mx-3">
            <label>ใช้งานได้เฉพาะ</label>
            <v-radio-group class="mt-2 px-5" v-model="duty.is_office">
              <v-radio label="ในสำนักงาน" :value="true"></v-radio>
              <v-radio label="นอกสถานที่" :value="false"></v-radio>
            </v-radio-group>
          </div>
        </v-row> -->
        <!-- <v-row class="mt-2" v-if="duty.is_display_on_mobile">
          <div class="mx-3">
            <label>การบันทึกเวลาทำงาน</label>
            <v-radio-group class="mt-2 px-5" v-model="duty.is_tracking_only">
              <v-radio label="บันทึกเวลาทำงาน" :value="false"></v-radio>
              <v-radio label="ไม่บันทึกเวลาทำงาน" :value="true"></v-radio>
              <div class="ml-8 grey--text">
                <p class="mb-2">- ใช้เฉพาะ Tracking สถานที่ที่เคยไปเท่านั้น</p>
                <p>
                  - จะแสดงเฉพาะ เมื่อขณะนั้นพนักงานไม่มีสิทธิ์ลงเวลาประเภทอื่น
                </p>
              </div>
            </v-radio-group>
          </div>
        </v-row> -->
        <v-row class="mt-2">
          <div class="mx-3">
            <label>การบันทึกเวลาทำงาน</label>
            <v-radio-group class="mt-2 px-5" v-model="duty.is_tracking_only">
              <v-radio label="บันทึกเวลาทำงาน" :value="false"></v-radio>
              <v-radio label="ไม่บันทึกเวลาทำงาน" :value="true"></v-radio>
              <div class="ml-8 grey--text">
                <p class="mb-2 body-2">
                  - ใช้เฉพาะ Tracking สถานที่ที่เคยไปเท่านั้น
                </p>
                <p class="body-2">
                  - จะแสดงเฉพาะ เมื่อขณะนั้นพนักงานไม่มีสิทธิ์ลงเวลาประเภทอื่น
                </p>
              </div>
            </v-radio-group>
          </div>
        </v-row>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row
          justify="center"
          align="center"
          v-if="!isDutyDataChange && formAction === 'edit'"
        >
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::company_duty:delete')"
            icon
            @click="onDelete"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::company_duty:create')"
            tabindex="4"
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::company_duty:update')"
            tabindex="4"
            class="primary mr-3"
            depressed
            v-else
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    duty: {
      type: Object,
    },
    dutyInit: {
      type: Object,
    },
  },
  data() {
    return {
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      modalStartTime: false,
      modalEndTime: false,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isDutyDataChange() {
      if (
        this.duty.title_th !== this.dutyInit.title_th ||
        this.duty.title_en !== this.dutyInit.title_en ||
        this.duty.duty_code !== this.dutyInit.duty_code ||
        this.duty.duty_type_id !== this.dutyInit.duty_type_id ||
        this.duty.start_time !== this.dutyInit.start_time ||
        this.duty.end_time !== this.dutyInit.end_time ||
        this.duty.is_office !== this.dutyInit.is_office ||
        this.duty.is_display_on_mobile !== this.dutyInit.is_display_on_mobile ||
        this.duty.is_tracking_only !== this.dutyInit.is_tracking_only
      ) {
        this.$emit('isDutyDataChange', true)
        return true
      }
      this.$emit('isDutyDataChange', false)
      return false
    },
    dutiesType() {
      return this.$store.state.duty.dutiesType
    },
    ruleStartTime() {
      if (this.duty.end_time && !this.duty.start_time) return false
      return true
    },
    ruleEndTime() {
      if (this.duty.start_time && !this.duty.end_time) return false
      return true
    },
  },
  methods: {
    ...mapActions({
      addDuty: 'duty/addDuty',
      editDuty: 'duty/editDuty',
      deleteDuty: 'duty/deleteDuty',
    }),
    dutyClear(field) {
      this.duty[field] = undefined
    },
    checkEmpty(value, field) {
      if (value) {
        this.duty[field] = value.trim()
      }
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบ duty',
        value: this.duty.title_th,
        item: this.duty,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete(duty) {
      this.confirmDialogDeleteLoading = true

      const { company_uuid } = this.$store.state.authentication.company

      this.deleteDuty({
        companyUUID: company_uuid,
        companyDutyUUID: duty.company_duty_uuid,
      })
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$emit('formActionCompleted', this.formAction)
          this.$refs.form.reset()
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const newDuty = {
          title_th: this.duty.title_th,
          title_en: this.duty.title_en ? this.duty.title_en : null,
          duty_type_id: this.duty.duty_type_id,
          duty_code: this.duty.duty_code ? this.duty.duty_code : null,
          start_time: this.duty.start_time ? this.duty.start_time : null,
          end_time: this.duty.end_time ? this.duty.end_time : null,
          is_display_on_mobile: this.duty.is_display_on_mobile,
          is_office: this.duty.is_display_on_mobile
            ? this.duty.is_office
            : true,
          is_tracking_only: this.duty.is_display_on_mobile
            ? this.duty.is_tracking_only
            : false,
        }

        const { company_uuid } = this.$store.state.authentication.company

        this.addDuty({
          companyUUID: company_uuid,
          duty: newDuty,
        })
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'เพิ่มข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$emit('formActionCompleted', this.formAction)
            this.$refs.form.reset()
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const updateDuty = {
          title_th: this.duty.title_th,
          title_en: this.duty.title_en ? this.duty.title_en : null,
          duty_type_id: this.duty.duty_type_id,
          duty_code: this.duty.duty_code ? this.duty.duty_code : null,
          start_time: this.duty.start_time ? this.duty.start_time : null,
          end_time: this.duty.end_time ? this.duty.end_time : null,
          is_display_on_mobile: this.duty.is_display_on_mobile,
          is_office: this.duty.is_display_on_mobile
            ? this.duty.is_office
            : true,
          is_tracking_only: this.duty.is_display_on_mobile
            ? this.duty.is_tracking_only
            : false,
        }

        const { company_uuid } = this.$store.state.authentication.company

        this.editDuty({
          companyUUID: company_uuid,
          companyDutyUUID: this.duty.company_duty_uuid,
          duty: updateDuty,
        })
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'แก้ไขข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$emit('formActionCompleted', this.formAction)
            this.$refs.form.reset()
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onClose() {
      if (this.isDutyDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('formActionCompleted', this.formAction)
        this.$refs.form.reset()
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$emit('formActionCompleted', this.formAction)
      this.$refs.form.reset()
    },
    onReset() {
      if (this.formAction === 'add' || this.formAction === '') {
        this.$refs.form.reset()
      } else {
        this.$emit('onReset', this.formAction)
      }
    },
  },
}
</script>
